<template>
  <div class="lp-adm-drop-input-container">

    <div class="drop-input-select-wrapper" @click="isOpen=true" :style="wrapperStyle">
      <input class="drop-input-input" type="text" :value="selectedLabel" @input="searchKeyword" @focus="isOpen=true"
             @blur="onBlur" :placeholder="placeholder">
      <i v-if="!isOpen" class="material-icons drop-input-arrow-icon">keyboard_arrow_down</i>
      <i v-if="isOpen" class="material-icons drop-input-arrow-icon">keyboard_arrow_up</i>
    </div>

    <!--<div v-if="isOpen" class="drop-input-list-outsider" @click="isOpen=false"></div>-->

    <ul v-if="isOpen && list.length!==0" class="drop-input-list" :style="listStyle" @mouseover="trigger=false"
        @mouseleave="trigger=true">
      <li class="drop-input-item" v-for="(item,idx) in list" :key="'sort-list'+idx" @click="clickTargetItem(item)">{{
        item.label }}
      </li>
    </ul>

  </div>
</template>

<script>
  export default {
    props: ['data', 'placeholder', 'width', 'listAlign', 'selectVal', 'number_length'],
    data() {
      return {
        trigger: false,
        isOpen: false,
        selectedLabel: '',
        list: []
      }
    },
    created() {
      this.list = this.data;
      if (this.selectVal && this.selectVal > 0) this.selectedLabel = this.selectVal;
    },
    computed: {
      wrapperStyle() {
        let style = {};
        if (this.width !== undefined) {
          style.width = this.width;
        }
        return style;
      },
      listStyle() {
        let style = {};
        if (this.width !== undefined) {
          style.width = this.width;
        }
        if (this.listAlign !== undefined) {
          style.textAlign = this.listAlign;
        }
        return style;
      }
    },
    watch: {
      data(n) {
        this.list = n;
      },
      selectVal(n) {
        this.selectedLabel = n;
      }
    },
    methods: {
      searchKeyword(e) {
        this.selectedLabel = e.target.value;
        this.list = [];
        for (let i = 0; i < this.data.length; i++) {
          let reg = new RegExp('^' + this.selectedLabel);

          let isContain = this.data[i].label.toString().search(reg);

          if (isContain === 0) {
            this.list.push({
              label: this.data[i].label,
              value: this.data[i].value
            });
          }
          if (this.selectedLabel.length > this.number_length) {
            this.selectedLabel = this.selectedLabel.substr(0, this.number_length);
          }
        }
      },
      clickTargetItem(item) {
        console.log(item.label);
        this.$emit('onSelect', item);
        this.selectedLabel = item.label;
        this.isOpen = false;
      },
      onBlur() {
        if (this.trigger) {
          this.isOpen = false;
        }
      },
      onFocusout() {
        // this.isOpen=false;
        // if(this.list.length > 0)
        //   this.$emit('onSelect', this.list[0]);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-adm-drop-input-container
    position relative

  .drop-input-select-wrapper
    width 240px
    border 1px solid #ccc
    border-radius 3px
    display flex
    align-items center

  .drop-input-input
    width 85%
    border none
    font-size .9rem
    padding 7px 12px
    color #333
    ouline none

  .drop-input-arrow-icon
    font-size 1.2rem
    margin 0 8px
    cursor pointer

  .drop-input-list
    list-style none
    margin 0
    padding 0
    background-color #fff
    border 1px solid #ddd
    border-top none
    width 240px
    /*height 192px*/
    max-height: 192px;
    overflow-y auto
    position absolute
    top 38px
    left 0
    z-index 1

  .drop-input-item
    font-size .9rem
    color #555
    padding 8px 12px
    cursor pointer

  .drop-input-item:hover
    background-color #ddd

  // input placeholder style
  // .drop-input-input::-webkit-input-placeholder

</style>
